// src/pages/PageRenderer.jsx
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";
import SectionsRenderer from "./SectionsRenderer";
import NotFound from "../404";
import { motion } from "framer-motion";
import { useVenueName } from "../../hooks/useVenueName";
export default function PageRenderer() {
  const { pageId: encodedPageId } = useParams();
  const pageId = encodedPageId ? decodeURIComponent(encodedPageId) : "home";

  // Nowy hook – obsługuje zarówno :name z URL, jak i domyślną nazwę z bazy
  const { name, loading: nameLoading } = useVenueName();

  const [loading, setLoading] = useState(true);
  const [title, setTitle] = useState("");
  const [sections, setSections] = useState([]);
  const [sekcjaPowitalna, setSekcjaPowitalna] = useState(null);


  useEffect(() => {
    if (!name || !pageId) return;

    const fetchPage = async () => {
      setLoading(true);
      try {
        const ref = doc(db, "venues", name, "pages", pageId);
        const snap = await getDoc(ref);

        if (!snap.exists()) {
          setTitle("");
          setSections([]);
          setSekcjaPowitalna(null);
          return;
        }

        const data = snap.data();

        setTitle(data.title || "");

        // Sortowanie sekcji po order + migracja starych galerii
        setSections(
          (data.sections || [])
            .slice()
            .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
            .map((sec) => {
              if (sec.type === "gallery" && sec.images && Array.isArray(sec.images)) {
                if (sec.images.length > 0 && typeof sec.images[0] === "string") {
                  return {
                    ...sec,
                    images: sec.images.map((url, idx) => ({ url, order: idx })),
                  };
                }
              }
              return sec;
            })
        );

        // Sekcja powitalna dla wybranych stron
        if (data.sekcjaPowitalna && ["home", "kontakt", "galeria"].includes(pageId)) {
          setSekcjaPowitalna(data.sekcjaPowitalna);
        } else {
          setSekcjaPowitalna(null);
        }
      } catch (err) {
        console.error("Błąd ładowania strony:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPage();
  }, [name, pageId]);

  // Ładowanie strony lub motywu
  if (nameLoading || loading) {
    return (
      <div className="py-32 text-center text-gray-500">
        Ładowanie strony…
      </div>
    );
  }

  // Strona nie istnieje (oprócz home, który zawsze powinien istnieć)
  if (!title && sections.length === 0 && pageId !== "home") {
    return <NotFound />;
  }

  return (
  <motion.div 
    className="w-full min-h-screen" 
    initial={{ opacity: 0 }} 
    animate={{ opacity: 1 }} 
    exit={{ opacity: 0 }} 
    transition={{ duration: 0.3 }}
  >
    <SectionsRenderer
      title={title}
      sections={sections}
      showTitle={pageId !== "home" && pageId !== "kontakt" && pageId !== "galeria"}
      sekcjaPowitalna={sekcjaPowitalna}
    />
  </motion.div>
);
}